import React from "react";

import AppConfig from "../../config/AppConfig";
import AppView from "./AppView";

const App: React.FC = () => {
  AppConfig();
  return <AppView />;
};

export default App;
